import { TiltProps } from './types';

export const defaultTiltProps: TiltProps = {
  tiltEnable: true,
  tiltReverse: false,
  tiltAngleXInitial: 0,
  tiltAngleYInitial: 0,
  tiltMaxAngleX: 20,
  tiltMaxAngleY: 20,
  tiltAxis: null,
  tiltAngleXManual: null,
  tiltAngleYManual: null,
};
